<template>
  <el-container>
    <el-aside width="200px">
      <div class="menu">
        <el-menu
          class="el-menu-vertical"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          text-align="left"
          :router="true"
        >
          <el-menu-item index="/examSearch/paperDetails">
            <span slot="title">考试明细查询</span>
          </el-menu-item>
          <el-menu-item index="/home/message">
            <span slot="title">
              返回
            </span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-aside>
    <el-container>
      <el-header height="56px" style="background:#545c64;line-height:50px;color:white;">
        {{ $route.matched[1].props.default.name }}
      </el-header>
      <el-main style="padding:0;overflow-y:scroll;overflow-x:hidden;height:80vh">
        <div class="view">
          <router-view></router-view>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import api from '@/modules/api.js'
export default {
  name: 'Manage',
  data() {
    return {
      activeNames: [],
      show: false
    }
  },
  methods: {},
  mounted() {
    let submitInfo = {
      pid: '4a93cfd2882c4e4d929b43aae9f54e69'
    }
    let that = this
    // 调用接口保存告知数据
    api.getMenuInfo(submitInfo, function(res) {
      if (res.result.isSuccess === true) {
        console.log(123, res)
        if (res.data.menus.children.length == 2) {
          that.show = true
          window.sessionStorage.setItem('show','Y')
        }
      } else {
        that.$toast(res.result.error)
      }
    })
  }
}
</script>
<style scoped>
.background {
  background: #f2f2f2;
}
.aside {
  width: 10%;
}
.el-menu {
  border: 0px;
}
.el-menu-vertical {
  height: 100vh;
}
.menu {
  width: 100%;
  height: auto;
  margin: 0px auto;
  text-align: center;
  background: rgb(84, 92, 100);
}
.view {
  width: 100%;
  float: right;
}
.menu_container {
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/exam/examManage/examSearch.vue